import axios from 'axios';

export default {
	namespaced: true,
	state: {
		contentAvailable: false,
		posts: null,
		pages: null,
		galleries: null,
		playlists: null,
		forms: null,
		media: null,
		mainMenu: null,
		footerMenu: null,
	},
	mutations: {
		updateData(state, { target, newValue }) {
			let updatedValue = newValue;
			if (!Number.isNaN(Number(newValue)) && Number.isFinite(Number(newValue))) {
				updatedValue = Number(newValue);
			}
			state[target] = updatedValue;
		},
		updateContentAvailable(state, newValue) {
			state.contentAvailable = newValue;
		},
	},
	actions: {
		fetchData({ commit, state }, target) {
			if (state[target] === null) {
				let endpoint;
				switch (target) {
				case 'media':
					endpoint = 'media';
					break;
				case 'forms':
					endpoint = 'forms';
					break;
				case 'galleries':
					endpoint = 'galleries';
					break;
				case 'playlists':
					endpoint = 'playlists';
					break;
				case 'posts':
					endpoint = 'posts';
					break;
				case 'pages':
					endpoint = 'pages';
					break;
				case 'mainMenu':
					endpoint = 'main-menu';
					break;
				case 'footerMenu':
					endpoint = 'footer-menu';
					break;
				default:
					endpoint = null;
				}
				return axios.get(`/api/${endpoint}`)
					.then(result => commit('updateData', { target, newValue: result.data }))
					.catch(console.error);
			}
			return Promise.resolve();
		},
	},
	getters: {
		getData(state) {
			return target => state[target];
		},
		getDataById(state) {
			return (target, id) => {
				const parsedId = Number(id);
				return (state[target] !== null ? state[target].find(e => e.id === parsedId) : false);
			};
		},
	},
};
